<ng-container *ngIf="authorization; else noAuth">
  <app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

  <div class="form" style="padding-bottom: 70px">
    <div style="text-align: center; padding-bottom: 20px; padding-top: 20px; max-width: 1200px; margin: auto">
      <h3>{{ title }}</h3>
    </div>

    <form (ngSubmit)="onSubmit()">
      <div class="questionnaire-container">
        <div class="consent-box">
          <!-- Scrollable consent text -->
          <div class="consent-text scrollable" [innerHTML]="dataSource[0].question"></div>

          <!-- Question block -->
          <div class="question">
            <p>ACCONSENTO alla partecipazione al Progetto in questione (cfr. art. 2.1. lettera a) dell’informativa
              privacy.</p>

            <div class="answers">
              <mat-form-field>
                <mat-label>Seleziona un valore</mat-label>
                <mat-select (selectionChange)="selectResult($event.value, 1)">
                  <mat-option *ngFor="let value of values" [value]="value">
                    {{value | uppercase}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="submit-container">
          <button type="submit" mat-raised-button color="primary">Invia</button>
        </div>
      </div>
    </form>
  </div>
</ng-container>

<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'"
    [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>L'accesso a questa pagina non è autorizzato. Torna alla home</h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>